import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BBBMandantConf } from '@reflact/kick';
import { AuthService } from 'src/app/shared/AuthService';
import { BbbService } from '../bbb.service';

@Component({
  selector: 'app-global-settings',
  templateUrl: './global-settings.component.html',
  styles: [],
})
export class GlobalSettingsComponent implements OnInit {
  public config: BBBMandantConf;
  public logoUrl = '';
  public loginBackgroundUrl = '';
  public waitingRoomBackgroundUrl = '';
  @ViewChild('logoUpload') public logoUpload: ElementRef;
  @ViewChild('loginBackgroundUpload') public loginBackgroundUpload: ElementRef;
  @ViewChild('waitingRoomBackgroundUpload') public waitingRoomBackgroundUpload: ElementRef;

  constructor(
    public authService: AuthService,
    public service: BbbService,
  ) {
    this.loadMandantConfig();
  }

  public ngOnInit(): void {
    const short = this.authService.getUserObject().short;
    this.logoUrl = '/api/accountlogo/' + short;
    this.loginBackgroundUrl = '/api/loginbackground/' + short;
    this.waitingRoomBackgroundUrl = '/api/waitingroombackground/' + short;
  }

  public async uploadFile() {
    const file = this.logoUpload.nativeElement.files[0];
    const result = await this.service.uploadAccountLogo(file);
    if (result != null) {
      this.logoUrl =
        '/api/accountlogo/' +
        this.authService.getUserObject().short +
        '?' +
        Math.random();
    }
  }

  private loadMandantConfig() {
    if (!this.service.mandantConfig) {
      setTimeout(this.loadMandantConfig.bind(this), 200);
    } else {
      this.config = this.service.mandantConfig;
      if (!this.config.primaryColor) {
        this.config.primaryColor = '#122E7A';
      }
      if (!this.config.sidekickColor) {
        this.config.sidekickColor = '#122E7A';
      }
    }
  }

  public updateMandantConf() {
    this.uploadFile();
    this.service.updateBBBMandantConf(this.config);
  }

  public async uploadLoginBackground() {
    const file: File = this.loginBackgroundUpload.nativeElement.files[0];
    if (!file) return;
    const valid = await this.validateLoginBackgroundDimensions(file);
    if (!valid) return;
    const result = await this.service.uploadLoginBackground(file);
    if (result != null) {
      this.loginBackgroundUrl = '/api/loginbackground/' + this.authService.getUserObject().short + '?' + Math.random();
    }
  }

  public async deleteLoginBackground() {
    await this.service.deleteLoginBackground();
    this.loginBackgroundUrl = '';
  }

  // Validates that the selected image is exactly 1920x1080
  private validateLoginBackgroundDimensions(file: File): Promise<boolean> {
    return new Promise((resolve) => {
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(url);
        if (img.width !== 1920 || img.height !== 1080) {
          alert($localize`:@@login-bg-wrong-size:Das Bild muss exakt 1920×1080 Pixel groß sein.`);
          resolve(false);
        } else {
          resolve(true);
        }
      };
      img.onerror = () => { URL.revokeObjectURL(url); resolve(false); };
      img.src = url;
    });
  }

  public async resetMandantConf() {
    await this.service.deleteAccountLogo();
    this.config.webcamsOnlyForModerators = false;
    this.config.muteOnStart = false;
    this.config.primaryColor = '#122E7A';
    this.config.sidekickColor = '#122E7A';
    this.config.welcomeMessage = '';
    this.logoUrl = '/api/accountlogo?' + Math.random();
    this.service.updateBBBMandantConf(this.config);
  }

  public async uploadWaitingRoomBackground() {
    const file: File = this.waitingRoomBackgroundUpload.nativeElement.files[0];
    if (!file) return;
    const valid = await this.validateLoginBackgroundDimensions(file);
    if (!valid) return;
    const result = await this.service.uploadWaitingRoomBackground(file);
    if (result != null) {
      this.waitingRoomBackgroundUrl = '/api/waitingroombackground/' + this.authService.getUserObject().short + '?' + Math.random();
    }
  }

  public async deleteWaitingRoomBackground() {
    await this.service.deleteWaitingRoomBackground();
    this.waitingRoomBackgroundUrl = '';
  }
}